import { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import Topbar from "../../components/Topbar";
import api from "../../services/api";

const TIPOS = [
  { key:"INJETORA",    label:"Injetora Plastica" },
  { key:"CORTE",       label:"Serra / Corte de Aluminio" },
  { key:"TRANCADEIRA", label:"Trancadeira" },
  { key:"OUTRO",       label:"Outro" },
];
const STATUS = [
  { key:"ATIVA",      label:"Ativa" },
  { key:"MANUTENCAO", label:"Em Manutencao" },
  { key:"INATIVA",    label:"Inativa" },
];
const VAZIO = {
  nome:"", codigo:"", tipo:"INJETORA", status:"ATIVA",
  fabricante:"", modelo:"", ano:"",
  cavidades:1, forca_fechamento:0, num_fusos:1,
  potencia_kw:"0", custo_kwh:"0", manutencao_mensal:"0",
  horas_mes:"160", outros_custos_hora:"0",
  custo_hora:"0", maquinas_por_operador:1, observacoes:""
};
const fmt4 = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:4});
const fmt  = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const n    = (v) => parseFloat(v) || 0;
const STATUS_BADGE = { ATIVA:"badge-green", MANUTENCAO:"badge-amber", INATIVA:"badge-gray" };

export default function Configuracoes() {
  const [maquinas, setMaquinas]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [tipoAtivo, setTipoAtivo] = useState("TODOS");
  const [busca, setBusca]         = useState("");
  const [modalForm, setModalForm] = useState(null);
  const [form, setForm]           = useState(VAZIO);
  const [salvando, setSalvando]   = useState(false);

  const carregar = () => {
    setLoading(true);
    api.get("/maquinas/maquinas/")
      .then(res => setMaquinas(res.data.results || res.data))
      .catch(() => setMaquinas([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { carregar(); }, []);

  const filtradas = maquinas
    .filter(m => tipoAtivo === "TODOS" || m.tipo === tipoAtivo)
    .filter(m => m.nome.toLowerCase().includes(busca.toLowerCase()) || m.codigo.toLowerCase().includes(busca.toLowerCase()));

  const countTipo = (key) => key === "TODOS" ? maquinas.length : maquinas.filter(m => m.tipo === key).length;

  const abrirNovo   = () => { setForm(VAZIO); setModalForm("novo"); };
  const abrirEditar = (m) => { setForm({...m}); setModalForm("editar"); };
  const excluir = async (id) => {
    if (!window.confirm("Excluir esta maquina?")) return;
    await api.delete("/maquinas/maquinas/"+id+"/"); carregar();
  };
  const salvar = async () => {
    setSalvando(true);
    // Calcula custo_hora automaticamente antes de salvar
    const custoCalculado = n(form.potencia_kw) * n(form.custo_kwh)
      + (n(form.horas_mes) > 0 ? n(form.manutencao_mensal) / n(form.horas_mes) : 0)
      + n(form.outros_custos_hora);
    const dados = {...form, custo_hora: custoCalculado.toFixed(4)};
    try {
      if (modalForm === "novo") await api.post("/maquinas/maquinas/", dados);
      else await api.put("/maquinas/maquinas/"+form.id+"/", dados);
      carregar(); setModalForm(null);
    } catch(e) {
      alert(e.response?.data ? JSON.stringify(e.response.data) : "Erro ao salvar.");
    } finally { setSalvando(false); }
  };

  const upd = (field) => (e) => setForm(f => ({...f, [field]: e.target.value}));
  const campo = (label, field, opts={}) => (
    <div className="form-group">
      <label className="form-label">{label}</label>
      {opts.select
        ? <select className="form-select" value={form[field]||""} onChange={upd(field)}>{opts.options.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}</select>
        : <input className="form-input" value={form[field]||""} onChange={upd(field)} placeholder={opts.placeholder||""} type={opts.type||"text"} />
      }
    </div>
  );

  // Preview custo hora em tempo real
  const custoEnergia  = n(form.potencia_kw) * n(form.custo_kwh);
  const custoManut    = n(form.horas_mes) > 0 ? n(form.manutencao_mensal) / n(form.horas_mes) : 0;
  const custoOutros   = n(form.outros_custos_hora);
  const custoHoraCalc = custoEnergia + custoManut + custoOutros;

  const abas = [{ key:"TODOS", label:"Todas" }, ...TIPOS];

  return (
    <>
      <Topbar title="Configuracoes" />
      <div className="erp-content">
        <div style={{marginBottom:24}}>
          <div style={{fontSize:18,fontWeight:700,color:"var(--z-text-primary)",marginBottom:4}}>Maquinas</div>
          <div className="fs-13 text-secondary">Cadastro de maquinas e equipamentos de producao com calculo de custo/hora</div>
        </div>
        <div className="page-toolbar">
          <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> Nova maquina</button>
          <input className="form-input" style={{width:240}} placeholder="Buscar..." value={busca} onChange={e=>setBusca(e.target.value)} />
        </div>
        <div className="abas-wrapper mb-16">
          <div className="abas">
            {abas.map(a=>(
              <button key={a.key} className={"aba"+(tipoAtivo===a.key?" aba-ativa":"")} onClick={()=>setTipoAtivo(a.key)}>
                {a.label} <span className="aba-count">{countTipo(a.key)}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="card">
          <div className="table-wrapper">
            {loading ? <div className="table-empty">Carregando...</div>
            : filtradas.length === 0 ? <div className="table-empty">Nenhuma maquina encontrada.</div>
            : (
              <table>
                <thead><tr>
                  <th>Codigo</th><th>Nome</th><th>Tipo</th><th>Fabricante/Modelo</th>
                  <th>Potencia</th><th>Custo/hora</th><th>Maq/Op</th><th>Status</th><th></th>
                </tr></thead>
                <tbody>
                  {filtradas.map(m=>(
                    <tr key={m.id} className="tr-expandable" onClick={()=>abrirEditar(m)}>
                      <td className="td-mono">{m.codigo}</td>
                      <td><strong>{m.nome}</strong></td>
                      <td><span className="badge badge-blue">{m.tipo_display}</span></td>
                      <td style={{color:"var(--z-text-secondary)",fontSize:12}}>
                        {[m.fabricante, m.modelo, m.ano].filter(Boolean).join(" | ")||"-"}
                      </td>
                      <td className="text-secondary">{n(m.potencia_kw)>0?fmt(m.potencia_kw)+" kW":"-"}</td>
                      <td style={{fontWeight:500,color:"var(--z-blue)"}}>R$ {fmt4(m.custo_hora)}/h</td>
                      <td style={{textAlign:"center"}}>{m.maquinas_por_operador}</td>
                      <td><span className={`badge ${STATUS_BADGE[m.status]||"badge-gray"}`}>{m.status_display}</span></td>
                      <td className="td-r">
                        <button className="btn btn-danger" style={{fontSize:11,padding:"3px 8px"}}
                          onClick={e=>{e.stopPropagation();excluir(m.id);}}>
                          <i className="ti ti-trash"/>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {modalForm && (
        <Modal title={modalForm==="novo"?"Nova Maquina":"Editar Maquina"} onClose={()=>setModalForm(null)} size="lg"
          footer={<>
            <button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button>
            <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
          </>}>

          <div className="form-grid">
            {campo("Codigo","codigo",{placeholder:"Ex: INJ-01"})}
            {campo("Nome","nome",{placeholder:"Ex: Injetora Oriente"})}
            {campo("Tipo","tipo",{select:true,options:TIPOS.map(t=>({v:t.key,l:t.label}))})}
            {campo("Status","status",{select:true,options:STATUS.map(s=>({v:s.key,l:s.label}))})}
            {campo("Fabricante","fabricante",{placeholder:"Ex: Oriente"})}
            {campo("Modelo","modelo",{placeholder:"Ex: 140/250"})}
            {campo("Ano","ano",{type:"number",placeholder:"Ex: 1989"})}
            {campo("Maquinas por operador","maquinas_por_operador",{type:"number"})}
            {form.tipo==="INJETORA"    && campo("Cavidades","cavidades",{type:"number"})}
            {form.tipo==="INJETORA"    && campo("Forca fechamento (ton)","forca_fechamento",{type:"number"})}
            {form.tipo==="TRANCADEIRA" && campo("Numero de fusos","num_fusos",{type:"number"})}
          </div>

          <div className="form-section">Calculo de Custo/Hora</div>
          <div className="form-grid">
            {campo("Potencia (kW)","potencia_kw",{type:"number"})}
            {campo("Custo kWh (R$)","custo_kwh",{type:"number"})}
            {campo("Manutencao mensal (R$)","manutencao_mensal",{type:"number"})}
            {campo("Horas trabalhadas/mes","horas_mes",{type:"number"})}
            {campo("Outros custos/hora (R$)","outros_custos_hora",{type:"number"})}
          </div>

          {/* Preview do custo calculado */}
          <div style={{background:"#eef2ff",border:"1px solid #c7d2fe",borderRadius:6,padding:"12px 16px",marginTop:4}}>
            <div style={{fontSize:11,fontWeight:600,color:"#4338ca",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:8}}>
              Custo/hora calculado automaticamente
            </div>
            <div style={{display:"flex",gap:24,flexWrap:"wrap",fontSize:12,marginBottom:8}}>
              <span>Energia: <strong>R$ {fmt4(custoEnergia)}/h</strong></span>
              <span>Manutencao: <strong>R$ {fmt4(custoManut)}/h</strong></span>
              {custoOutros > 0 && <span>Outros: <strong>R$ {fmt4(custoOutros)}/h</strong></span>}
            </div>
            <div style={{fontSize:16,fontWeight:700,color:"#4338ca"}}>
              Total: R$ {fmt4(custoHoraCalc)}/hora
            </div>
          </div>

          <div className="form-section">Observacoes</div>
          <div className="form-group">
            <textarea className="form-input" rows={2} value={form.observacoes||""} onChange={upd("observacoes")} />
          </div>
        </Modal>
      )}
    </>
  );
}
